<template>
  <div class="container text-left">
    <div class="row">
      <div class="col-12">
        <h2>전시품/미술품</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p>
          전시품 까르넷 통관 및 갤러리 배송
          전시 후 RETURN 선적
        </p>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        name: "Art"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Art.vue